export default __webpack_public_path__ + "static/media/510.c2acdb85.gif";